export default __webpack_public_path__ + "static/media/files-glery3.b50fb3a4.jpg";